module.exports = __webpack_public_path__ + "static/media/html.3e2a192e.png";